import { render, staticRenderFns } from "./Three.vue?vue&type=template&id=01acf20c&scoped=true"
import script from "./Three.vue?vue&type=script&lang=js"
export * from "./Three.vue?vue&type=script&lang=js"
import style0 from "./Three.vue?vue&type=style&index=0&id=01acf20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01acf20c",
  null
  
)

export default component.exports